import type { ReactNode } from 'react';

interface AppShellProps {
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

/**
 * Feste Drei-Zeilen-Bühne (GDD §32, §38).
 *
 * `100dvh` statt `100vh`, weil die iOS-Safari-Adressleiste bei `vh` den
 * unteren Aktionsbutton abschneiden kann. Nur `main` scrollt; Header und
 * Footer bleiben fix, damit Timer und primäre Aktion immer sichtbar sind.
 */
export function AppShell({ header, footer, children }: AppShellProps) {
  return (
    <div className="flex h-dvh flex-col bg-bg text-fg">
      {header && (
        <header
          className="flex shrink-0 items-center justify-between gap-2 border-b border-surface-border px-4"
          style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top))', paddingBottom: '0.75rem' }}
        >
          {header}
        </header>
      )}

      <main className="flex-1 overflow-y-auto overscroll-contain px-4 py-4">{children}</main>

      {footer && (
        <footer
          className="shrink-0 border-t border-surface-border bg-bg px-4 pt-3"
          style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
        >
          {footer}
        </footer>
      )}
    </div>
  );
}
